import React from 'react';

const Features = () => {
  return (
    <section id="features" className="min-h-screen flex items-center bg-primary" aria-labelledby="features-title">
      <div className="container mx-auto px-4 md:px-6 py-16">
        <div className="text-center mb-16">
          <h2 id="features-title" className="text-4xl font-bold mb-4">Elevate Your Experience</h2>
          <p className="text-lightText max-w-2xl mx-auto">
            Subtle, powerful solutions that transform how you connect with your customers.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <article className="bg-cardBg p-8 rounded-lg">
            <h3 className="text-2xl font-semibold mb-4 text-purple-500">Seamless</h3>
            <p className="text-lightText">
              Experience interactions that feel natural and effortless, creating meaningful connections with your customers.
            </p>
          </article>
          
          <article className="bg-cardBg p-8 rounded-lg">
            <h3 className="text-2xl font-semibold mb-4 text-purple-500">Insights</h3>
            <p className="text-lightText">
              Unlock powerful insights that enable your business to understand and serve customers better, creating exceptional experiences that drive loyalty and growth.
            </p>
          </article>
          
          <article className="bg-cardBg p-8 rounded-lg">
            <h3 className="text-2xl font-semibold mb-4 text-purple-500">Intelligence</h3>
            <p className="text-lightText">
              Behind every interaction is a sophisticated system that delivers exceptional experiences.
            </p>
          </article>
        </div>
      </div>
    </section>
  );
};

export default Features;
